import React from "react";
import "../../styles/containers/greeting/GreetingImage.css";
import heroImg from "../../assets/images/Fraz_portfolio_hero_high_quality.png";

/* Each tech has an inline SVG icon + label shown on hover */
const techStacks = [
  {
    name: "Python",
    icon: (
      <svg viewBox="0 0 24 24" fill="#3776AB">
        <path d="M12 0C5.372 0 5.727 2.978 5.727 2.978l.007 3.085h6.39V7h-8.93S0 6.523 0 12.12c0 5.596 3.247 5.397 3.247 5.397h1.94v-2.598s-.105-3.26 3.204-3.26h5.517s3.092.05 3.092-2.993V3.13S17.487 0 12 0zm-3.064 1.814a.994.994 0 011 1 .994.994 0 01-1 1 .994.994 0 01-1-1 .994.994 0 011-1z" />
        <path d="M12 24c6.628 0 6.273-2.978 6.273-2.978l-.007-3.085h-6.39V17h8.93S24 17.477 24 11.88c0-5.596-3.247-5.397-3.247-5.397h-1.94v2.598s.105 3.26-3.204 3.26H10.09s-3.092-.05-3.092 2.993v5.536S6.513 24 12 24zm3.064-1.814a.994.994 0 01-1-1 .994.994 0 011-1 .994.994 0 011 1 .994.994 0 01-1 1z" />
      </svg>
    ),
  },
  {
    name: "React",
    icon: (
      <svg viewBox="-11.5 -10.23 23 20.46" fill="#61DAFB">
        <circle cx="0" cy="0" r="2.05" />
        <g stroke="#61DAFB" strokeWidth="1" fill="none">
          <ellipse rx="11" ry="4.2" />
          <ellipse rx="11" ry="4.2" transform="rotate(60)" />
          <ellipse rx="11" ry="4.2" transform="rotate(120)" />
        </g>
      </svg>
    ),
  },
  {
    name: "Flutter",
    icon: (
      <svg viewBox="0 0 24 24" fill="#02569B">
        <path d="M14.314 0L2.3 12 6 15.7 21.684.013h-7.357zm.014 11.072L7.857 17.53l6.47 6.47H21.7l-6.46-6.468 6.46-6.46h-7.37z" />
      </svg>
    ),
  },
  {
    name: "Node.js",
    icon: (
      <svg viewBox="0 0 24 24" fill="#339933">
        <path d="M11.998 24c-.321 0-.641-.084-.922-.247l-2.936-1.737c-.438-.245-.224-.332-.08-.383.585-.203.703-.25 1.328-.604.065-.037.151-.023.218.017l2.256 1.339a.29.29 0 00.272 0l8.795-5.076a.277.277 0 00.134-.238V6.921a.28.28 0 00-.137-.242L12.135 1.6a.272.272 0 00-.27 0L3.07 6.68a.278.278 0 00-.138.24v10.15c0 .099.053.19.137.236l2.409 1.392c1.307.654 2.108-.116 2.108-.89V7.787c0-.142.114-.253.256-.253h1.115c.139 0 .255.112.255.253v10.021c0 1.745-.95 2.745-2.604 2.745-.508 0-.909 0-2.026-.551L2.28 18.675A1.857 1.857 0 011.357 17.07V6.921c0-.681.363-1.317.957-1.655L11.11.191a1.929 1.929 0 011.846 0l8.794 5.075c.594.339.957.975.957 1.655V17.07c0 .68-.363 1.316-.957 1.654l-8.794 5.076a1.834 1.834 0 01-.958.2z" />
      </svg>
    ),
  },
  {
    name: "C++",
    icon: (
      <svg viewBox="0 0 24 24" fill="#00599C">
        <path d="M22.394 6c-.167-.29-.398-.543-.652-.69L12.926.22c-.509-.294-1.34-.294-1.848 0L2.26 5.31c-.508.293-.923 1.013-.923 1.6v10.18c0 .294.104.62.271.91.167.29.398.543.652.69l8.816 5.09c.508.293 1.34.293 1.848 0l8.816-5.09c.254-.147.485-.4.652-.69.167-.29.27-.616.27-.91V6.91c.003-.294-.1-.62-.268-.91zM12 19.11c-3.92 0-7.109-3.19-7.109-7.11 0-3.92 3.19-7.11 7.11-7.11a7.133 7.133 0 016.156 3.553l-3.076 1.78a3.567 3.567 0 00-3.08-1.78A3.56 3.56 0 008.444 12 3.56 3.56 0 0012 15.555a3.57 3.57 0 003.08-1.778l3.078 1.78A7.135 7.135 0 0112 19.11zm7.11-6.715h-.79v.79h-.79v-.79h-.79v-.79h.79v-.79h.79v.79h.79zm2.962 0h-.79v.79h-.79v-.79h-.79v-.79h.79v-.79h.79v.79h.79z" />
      </svg>
    ),
  },
  {
    name: "MongoDB",
    icon: (
      <svg viewBox="0 0 24 24" fill="#47A248">
        <path d="M17.193 9.555c-1.264-5.58-4.252-7.414-4.573-8.115-.28-.394-.53-.954-.735-1.44-.036.495-.055.685-.523 1.184-.723.566-4.438 3.682-4.74 10.02-.282 5.912 4.27 9.435 4.888 9.884l.07.05A73.49 73.49 0 0111.91 24h.481c.114-1.032.284-2.056.51-3.07.417-.296.604-.463.85-.693a11.342 11.342 0 003.639-8.464c.01-.814-.103-1.662-.197-2.218zm-5.336 8.195s0-8.291.275-8.29c.274 0 .288 6.112.288 6.112l-.002 5.864-.56-3.686z" />
      </svg>
    ),
  },
  {
    name: "Docker",
    icon: (
      <svg viewBox="0 0 24 24" fill="#2496ED">
        <path d="M13.983 11.078h2.119a.186.186 0 00.186-.185V9.006a.186.186 0 00-.186-.186h-2.119a.186.186 0 00-.185.185v1.888c0 .102.083.185.185.185zm-2.954-5.43h2.118a.186.186 0 00.186-.186V3.574a.186.186 0 00-.186-.185h-2.118a.186.186 0 00-.185.185v1.888c0 .102.082.185.185.186zm0 2.716h2.118a.187.187 0 00.186-.186V6.29a.186.186 0 00-.186-.185h-2.118a.186.186 0 00-.185.185v1.887c0 .102.082.186.185.186zm-2.93 0h2.12a.186.186 0 00.184-.186V6.29a.185.185 0 00-.185-.185H8.1a.186.186 0 00-.185.185v1.887c0 .102.083.186.185.186zm-2.964 0h2.119a.186.186 0 00.185-.186V6.29a.186.186 0 00-.185-.185H5.136a.186.186 0 00-.186.185v1.887c0 .102.084.186.186.186zm5.893 2.715h2.118a.186.186 0 00.186-.185V9.006a.186.186 0 00-.186-.186h-2.118a.186.186 0 00-.185.185v1.888c0 .102.082.185.185.185zm-2.93 0h2.12a.185.185 0 00.184-.185V9.006a.185.185 0 00-.184-.186h-2.12a.185.185 0 00-.184.185v1.888c0 .102.083.185.185.185zm-2.964 0h2.119a.186.186 0 00.185-.185V9.006a.186.186 0 00-.185-.186H5.136a.186.186 0 00-.186.185v1.888c0 .102.084.185.186.185zm-2.92 0h2.12a.185.185 0 00.184-.185V9.006a.185.185 0 00-.184-.186h-2.12a.186.186 0 00-.186.186v1.887c0 .102.084.185.186.185zm10.893.001h2.119a.186.186 0 00.185-.185V9.006a.186.186 0 00-.185-.186h-2.119a.186.186 0 00-.186.186v1.887c0 .102.084.185.186.185zM23.763 9.89c-.065-.051-.672-.51-1.954-.51-.338.001-.676.03-1.01.087-.248-1.7-1.653-2.53-1.716-2.566l-.344-.199-.226.327c-.284.438-.49.922-.612 1.43-.23.97-.09 1.882.403 2.661-.595.332-1.55.413-1.744.42H.751a.751.751 0 00-.75.748 11.376 11.376 0 00.692 4.062c.545 1.428 1.355 2.48 2.41 3.124 1.18.723 3.1 1.137 5.275 1.137.983.003 1.963-.086 2.93-.266a12.248 12.248 0 003.823-1.389c.98-.567 1.86-1.288 2.61-2.136 1.252-1.418 1.998-2.997 2.553-4.4h.221c1.372 0 2.215-.549 2.68-1.009.309-.293.55-.65.707-1.046l.098-.288z" />
      </svg>
    ),
  },
  {
    name: "AWS",
    icon: (
      <svg viewBox="0 0 24 24" fill="#FF9900">
        <path d="M6.763 10.036c0 .296.032.535.088.71.064.176.144.368.256.576.04.063.056.127.056.183 0 .08-.048.16-.152.24l-.503.335a.383.383 0 01-.208.072c-.08 0-.16-.04-.239-.112a2.47 2.47 0 01-.287-.375 6.18 6.18 0 01-.248-.471c-.622.734-1.405 1.101-2.347 1.101-.67 0-1.205-.191-1.596-.574-.391-.384-.59-.894-.59-1.533 0-.678.239-1.23.726-1.644.487-.415 1.133-.623 1.955-.623.272 0 .551.024.846.064.296.04.6.104.918.176v-.583c0-.607-.127-1.03-.375-1.277-.255-.248-.686-.367-1.3-.367-.28 0-.568.031-.863.103a6.395 6.395 0 00-.862.271 2.296 2.296 0 01-.28.104.488.488 0 01-.127.023c-.112 0-.168-.08-.168-.247v-.391c0-.128.016-.224.056-.28a.597.597 0 01.224-.167 4.57 4.57 0 01.998-.36A4.84 4.84 0 016.02 5.13c.758 0 1.31.172 1.667.519.35.346.527.87.527 1.571v2.07h.005zm-3.24 1.214c.263 0 .534-.048.822-.144.287-.096.543-.271.758-.51a1.2 1.2 0 00.319-.51c.056-.192.096-.423.096-.694v-.335a6.66 6.66 0 00-.735-.136 6.02 6.02 0 00-.75-.048c-.535 0-.926.104-1.19.32-.263.215-.39.518-.39.917 0 .375.095.655.295.846.191.2.47.294.774.294zm6.41 1.087c-.144 0-.24-.024-.304-.08-.064-.048-.12-.16-.168-.311L7.586 5.55a1.398 1.398 0 01-.072-.32c0-.128.064-.2.191-.2h.783c.151 0 .255.025.31.08.065.048.113.16.16.312l1.342 5.284 1.245-5.284c.04-.16.088-.264.151-.312a.549.549 0 01.32-.08h.638c.152 0 .256.025.32.08.063.048.12.16.151.312l1.261 5.348 1.381-5.348c.048-.16.104-.264.16-.312a.52.52 0 01.311-.08h.743c.128 0 .2.065.2.2 0 .04-.009.08-.017.128a1.137 1.137 0 01-.056.2l-1.923 6.17c-.048.16-.104.263-.168.311a.51.51 0 01-.303.08h-.687c-.151 0-.255-.024-.32-.08-.063-.056-.119-.16-.15-.32l-1.238-5.148-1.23 5.14c-.04.16-.087.272-.15.328-.064.048-.177.08-.32.08zm10.256.215c-.415 0-.83-.048-1.229-.143-.399-.096-.71-.2-.918-.32-.128-.071-.215-.151-.247-.223a.563.563 0 01-.048-.224v-.407c0-.167.064-.247.183-.247.048 0 .096.008.144.024.048.016.12.048.2.08.271.12.566.215.878.279.319.064.63.096.95.096.502 0 .894-.088 1.165-.264a.86.86 0 00.415-.758.777.777 0 00-.215-.559c-.144-.151-.415-.287-.806-.415l-1.157-.36c-.583-.183-1.014-.454-1.277-.813a1.902 1.902 0 01-.4-1.158c0-.335.073-.63.216-.886.144-.255.335-.479.575-.654.24-.184.51-.32.83-.415A3.58 3.58 0 0118.374 5c.199 0 .407.008.614.024.2.016.391.04.575.071.176.04.343.08.503.128.16.048.287.096.383.144a.75.75 0 01.255.168.39.39 0 01.072.247v.375c0 .168-.064.256-.184.256a.824.824 0 01-.303-.096 3.652 3.652 0 00-1.532-.311c-.455 0-.815.071-1.062.223-.248.152-.375.383-.375.71 0 .224.08.416.24.567.159.152.454.304.877.44l1.134.358c.574.184.99.44 1.237.767.247.327.367.702.367 1.117 0 .343-.072.655-.207.926a2.163 2.163 0 01-.575.702 2.561 2.561 0 01-.878.447 3.82 3.82 0 01-1.142.16z" />
        <path d="M21.698 16.998c-2.606 1.922-6.39 2.943-9.64 2.943-4.564 0-8.68-1.686-11.789-4.494-.245-.222-.024-.524.267-.352 3.356 1.95 7.506 3.13 11.793 3.13 2.891 0 6.07-.6 8.996-1.84.44-.191.814.287.373.613z" />
        <path d="M22.762 15.724c-.332-.424-2.194-.2-3.032-.103-.254.032-.295-.19-.063-.351 1.484-1.044 3.916-.742 4.2-.392.287.358-.079 2.826-1.468 4.005-.215.18-.415.087-.319-.151.311-.774 1.004-2.583.682-3.008z" />
      </svg>
    ),
  },
  {
    name: "Firebase",
    icon: (
      <svg viewBox="0 0 24 24" fill="#FFCA28">
        <path d="M3.89 15.673L6.255.461A.542.542 0 017.27.289l2.543 4.771zm16.794 3.692l-2.25-14a.54.54 0 00-.919-.295L3.316 19.365l7.856 4.427a1.621 1.621 0 001.588 0zM14.3 7.148l-1.82-3.482a.542.542 0 00-.96 0L3.53 17.984z" />
      </svg>
    ),
  },
  {
    name: "SQL",
    icon: (
      <svg viewBox="0 0 24 24" fill="#4479A1">
        <path d="M12 3C7.58 3 4 4.79 4 7s3.58 4 8 4 8-1.79 8-4-3.58-4-8-4zM4 9v3c0 2.21 3.58 4 8 4s8-1.79 8-4V9c0 2.21-3.58 4-8 4S4 11.21 4 9zm0 5v3c0 2.21 3.58 4 8 4s8-1.79 8-4v-3c0 2.21-3.58 4-8 4s-8-1.79-8-4z" />
      </svg>
    ),
  },
  {
    name: "TypeScript",
    icon: (
      <svg viewBox="0 0 24 24" fill="#3178C6">
        <path d="M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 011.306.34v2.458a3.95 3.95 0 00-.643-.361 5.093 5.093 0 00-.717-.26 5.453 5.453 0 00-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 00-.623.242c-.17.104-.3.229-.393.374a.888.888 0 00-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 01-1.012 1.085 4.38 4.38 0 01-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 01-1.84-.164 5.544 5.544 0 01-1.512-.493v-2.63a5.033 5.033 0 003.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 00-.074-1.089 2.12 2.12 0 00-.537-.5 5.597 5.597 0 00-.807-.444 27.72 27.72 0 00-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 011.47-.629 7.536 7.536 0 011.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z" />
      </svg>
    ),
  },
  {
    name: "TensorFlow",
    icon: (
      <svg viewBox="0 0 24 24" fill="#FF6F00">
        <path d="M1.292 5.856L11.54 0v24l-4.095-2.378V7.603l-3.079 1.791-3.074-1.78zm21.416 0L12.46 0v24l4.095-2.378V14.29l3.079 1.791 3.074-1.78zM16.555 13.052l-4.095-2.378v4.756z" />
      </svg>
    ),
  },
  {
    name: "Figma",
    icon: (
      <svg viewBox="0 0 24 24" fill="#F24E1E">
        <path d="M15.852 8.981h-4.588V0h4.588c2.476 0 4.49 2.014 4.49 4.49s-2.014 4.491-4.49 4.491zM12.735 7.51h3.117c1.665 0 3.019-1.355 3.019-3.019 0-1.665-1.354-3.019-3.019-3.019h-3.117V7.51zm0 1.471H8.148c-2.476 0-4.49-2.014-4.49-4.49S5.672 0 8.148 0h4.587v8.981zm-4.587-7.51c-1.665 0-3.019 1.355-3.019 3.019 0 1.665 1.354 3.019 3.019 3.019h3.117V1.471H8.148zm4.587 15.019H8.148c-2.476 0-4.49-2.014-4.49-4.49s2.014-4.49 4.49-4.49h4.587v8.98zm-4.587-7.509c-1.665 0-3.019 1.355-3.019 3.019 0 1.665 1.354 3.019 3.019 3.019h3.117V8.981H8.148zm4.587 15.019c-2.476 0-4.49-2.014-4.49-4.49s2.014-4.49 4.49-4.49h4.588v8.98h-4.588zm0-7.509c-1.665 0-3.019 1.355-3.019 3.019 0 1.665 1.354 3.019 3.019 3.019h3.117v-6.038h-3.117zm4.588 7.509c2.476 0 4.49-2.014 4.49-4.49s-2.014-4.49-4.49-4.49h-3.117v8.98h3.117z" />
      </svg>
    ),
  },
  {
    name: "Git",
    icon: (
      <svg viewBox="0 0 24 24" fill="#F05032">
        <path d="M23.546 10.93L13.067.452a1.55 1.55 0 00-2.188 0L8.708 2.627l2.76 2.76a1.838 1.838 0 012.327 2.341l2.66 2.66a1.838 1.838 0 011.9 3.039 1.837 1.837 0 01-2.6 0 1.846 1.846 0 01-.336-2.1l-2.48-2.48v6.53a1.84 1.84 0 01.5.317 1.838 1.838 0 010 2.6 1.838 1.838 0 01-2.6 0 1.838 1.838 0 010-2.6c.192-.192.42-.33.665-.41V9.13a1.84 1.84 0 01-.665-.41 1.845 1.845 0 01-.336-2.1L8.77 3.89.454 12.207a1.55 1.55 0 000 2.188l10.48 10.48a1.55 1.55 0 002.186 0l10.426-10.428a1.55 1.55 0 000-2.187z" />
      </svg>
    ),
  },
  {
    name: "Dart",
    icon: (
      <svg viewBox="0 0 24 24" fill="#0175C2">
        <path d="M4.105 4.105S9.158 1.58 11.684.316a3.079 3.079 0 011.481-.315c.766.047 1.677.788 1.677.788L24 9.948V9.89l-4.27 11.661-7.927-.001L4.105 4.105zm7.036 13.332l6.013-2.585-3.27-8.583-6.913-1.982 4.17 13.15z" />
      </svg>
    ),
  },
  {
    name: "Kotlin",
    icon: (
      <svg viewBox="0 0 24 24" fill="#7F52FF">
        <path d="M24 24H0V0h24L12 12z" />
      </svg>
    ),
  },
];

export default function GreetingImage({ theme }) {
  const [touched, setTouched] = React.useState(false);

  return (
    <div className="greeting-image-container">
      {/* Concentric circles (ripple effect) */}
      <div className="ripple-container">
        <div
          className="ripple ripple-1"
          style={{ borderColor: theme.imageHighlight }}
        />
        <div
          className="ripple ripple-2"
          style={{ borderColor: theme.imageHighlight }}
        />
        <div
          className="ripple ripple-3"
          style={{ borderColor: theme.imageHighlight }}
        />
        <div
          className="ripple ripple-4"
          style={{ borderColor: theme.imageHighlight }}
        />
        <div
          className="ripple ripple-5"
          style={{ borderColor: theme.imageHighlight }}
        />
      </div>

      <div
        className={`greeting-image-wrapper ${touched ? "touched" : ""}`}
        onClick={() => setTouched(!touched)}
        onMouseLeave={() => setTouched(false)}
      >
        <div className="greeting-image-content">
          <img
            loading="lazy"
            alt="Fraz Liaqat Hero Portrait"
            src={heroImg}
            className="greeting-fraz-image"
          />
        </div>

        {/* Tech Stack Hover Overlay */}
        <div
          className="tech-stack-overlay"
          style={{
            background: `linear-gradient(135deg, #0a2463ee, #1e6091ee, #3a86c8ee)`,
          }}
        >
          <h3 className="tech-overlay-title">My Tech Stack</h3>
          <div className="tech-tags-grid">
            {techStacks.map((tech, i) => (
              <span
                key={i}
                className="tech-tag"
                style={{ animationDelay: `${i * 0.05}s` }}
              >
                <span className="tech-tag-icon">{tech.icon}</span>
                <span className="tech-tag-name">{tech.name}</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
